import axios from "../utilities/api/axiosInstance";
import getTagList from "@utils/text/getTagList";
import { printInConsole } from "@utils/devtools/utils";

export async function getComments({
  feedID,
  ts = 0,
  cancelToken,
  accessToken,
}) {
  /*
  Returns the list of comments for a post
  */
  if (!accessToken) {
    accessToken = "";
  }
  //console.log("getComments", { feedID, ts, accessToken });

  let link,
    data = [],
    err = null;

  if (ts === 0) link = `feed/comment?feedID=${feedID}`;
  else link = `feed/comment?feedID=${feedID}&ts=${ts}`;

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "GET",
    url: encodeURI(link),
    cancelToken: cancelToken,
  }).catch((error) => {
    err = error;
  });

  //printInConsole("Comment Fetch response => ", response);

  if (response?.data?.success) data = response.data.response;
  else if (response?.data?.message) err = response?.data?.message;
  // console.log("Comment Fetch response => ", response?.data?.response);
  return { data, err };
}

export async function createComment({ data, accessToken }) {
  /*
   data --> { feedID, communityID, comment(text), tagList, userTagList }

   returns the comment data or null
  */

  const tagList = getTagList(data.comment);
  data.tagList = tagList;

  const response = await axios({
    method: "POST",
    url: encodeURI("feed/comment"),
    data: data,
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
  }).catch((err) => {
    printInConsole(err);
  });

  printInConsole("Comment response => ", response);

  if (response?.data?.success) {
    return response.data;
  }
  else if(response?.data?.success===false && response?.data?.message==="Comment contains vulgar words") return response.data;
  return response?.data;
}

export async function deleteComment({ feedID, commentID, accessToken }) {
  /*
  Returns true/false
  */
  //console.log("Delete comment", feedID, commentID);
  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "DELETE",
    url: encodeURI("feed/comment"),
    data: { feedID, commentID },
  }).catch((err) => {
    printInConsole(err);
  });

  printInConsole("Comment Delete response => ", response);

  if (response?.data) {
    return response.data.success;
  }

  return false;
}

export async function updateComment({ data, accessToken }) {
  /*
  data --> { commentID, comment(updatedText), tagList, userTagList }

  returns true/false **
  */

  // const tagList = getTagList(comment);
  const response = await axios({
    method: "PUT",
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    url: encodeURI("feed/comment"),
    data: data,
  });

  printInConsole("Edit comment response => ", response);
  if (response?.data) {
    if (response.data.success) return response.data.success;
  }

  return false;
}

export async function likeComment({ commentID, accessToken, type }) {
  /*
  Like request for comment
  ----!! No return value !!----
  */
  //console.log("Comment Like => ", type);
  const response = await axios({
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    method: "POST",
    url: encodeURI(`${type}/comment/like`),
    data: { commentID },
  }).catch((err) => {
    printInConsole(err);
  });

  return response?.data;
  //console.log("Comment Like response => ", response);
}

export async function unlikeComment({ commentID, accessToken, type }) {
  /*
  Unlike request for comment
  ----!! No return value !!----
  */

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "DELETE",
    url: encodeURI(`${type}/comment/like`),
    data: { commentID },
  }).catch((err) => {
    printInConsole(err);
  });

  printInConsole("Comment Unlike response => ", response);
}

export async function reportComment({ commentID, accessToken }) {
  /*
  Returns true/false
  */

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "POST",
    url: encodeURI("feed/comment/report"),
    data: { commentID },
  }).catch((err) => {
    printInConsole(err);
  });

  printInConsole("Comment report response => ", response);

  return response?.data;
}

export async function getCommentLikesList({
  commentID,
  ts = 0,
  accessToken,
  type,
}) {
  /*
  Returns the list of users who liked the comment
  */
  //console.log("Type: ",type);
  let link;
  if (ts === 0) link = `${type}/comment/like?commentID=${commentID}`;
  else link = `${type}/comment/like?commentID=${commentID}&ts=${ts}`;

  const response = await axios({
    method: "GET",
    url: encodeURI(link),
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
  }).catch((err) => {
    printInConsole(err);
  });

  printInConsole("Comment LikeList response => ", response);

  if (response?.data?.success) return response.data.response;

  return [];
}
export async function getReplyLikesList({
  commentID,
  ts = 0,
  accessToken,
  type,
}) {
  /*
  Returns the list of users who liked the comment
  */
  let link;
  if (ts === 0) link = `${type}/comment/like?commentID=${commentID}`;
  else link = `${type}/comment/like?commentID=${commentID}&ts=${ts}`;

  const response = await axios({
    method: "GET",
    url: encodeURI(link),
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
  }).catch((err) => {
    printInConsole(err);
  });

  printInConsole("Comment LikeList response => ", response);

  if (response?.data?.success) return response.data.response;

  return [];
}
